import type { SyntheticEvent } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const stopEventPropagation = (e: SyntheticEvent<any, Event>) => e.stopPropagation();

export default stopEventPropagation;
